import type { BillingCommandStatus } from "@intelligems/ig-types/dtos/billing/commands/status";

const TERMINAL_NON_COMPLETED_BILLING_COMMAND_STATUSES =
  new Set<BillingCommandStatus>([
    "rejected",
    "failed_retryable",
    "failed_exhausted",
    "abandoned_external_approval",
    "recorded",
    "cancelled",
  ]);

export const isTerminalNonCompletedBillingCommandStatus = (
  status: BillingCommandStatus | undefined
): boolean =>
  status !== undefined &&
  TERMINAL_NON_COMPLETED_BILLING_COMMAND_STATUSES.has(status);
